import colors from '@/theme/colors';
import { css } from '@emotion/css';

const styles = {
  container: css`
    & > .MuiIconButton-root {
      color: ${colors.prussian};
      padding: 8px;
    }
  `,
};

export default styles;
